interface Suscriptions{
    suscriptionType:string,
    enabled:boolean
}

interface PaymentType{
    paymentType:string,
    enabled:boolean
}

interface UserData{
    id:number;
    username: string;
    first_name: string;
    last_name: string;
    new_user?: boolean;
    v:string;
    avatar_url?:string;
    location_id: number;    
    location_name: string;
    city_id?: number;
    city_name?: string;
    no_delivery: boolean;
    inc_no_delivery: boolean;
    settings_set: boolean;
    payment_methods: PaymentType[];
    suscriptions: Suscriptions[];
    premium_user: boolean,
    premium_expiration: string | null;
    /**
     * Post-login flag signalling that the user completed the onboarding
     * wizard after authentication. Read by `usePersistOnboardingData` on
     * `/store` to decide whether to flush the persisted onboarding draft to
     * the backend. Owned by the auth/backend contract — the frontend only
     * reads it.
     */
    onb_completed?: boolean;
}

const userDataDefault:UserData = {
    id:0,
    username: "",
    first_name: "",
    last_name: "",
    v:"1",
    location_id: 1,    
    location_name: "Default Location",
    no_delivery: false,
    inc_no_delivery: false,
    settings_set: false,
    payment_methods: [],
    suscriptions: [],
    premium_user: false,
    premium_expiration: null
}


export type {UserData}
export {userDataDefault}